/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ConcernStatusDto } from './concernStatusDto.schema';

export const IReadOnlyListOfConcernStatusDto = zod.array(zod.lazy(() => ConcernStatusDto));

export type IReadOnlyListOfConcernStatusDto = zod.input<typeof IReadOnlyListOfConcernStatusDto>;
export type IReadOnlyListOfConcernStatusDtoOutput = zod.output<typeof IReadOnlyListOfConcernStatusDto>;
